// @flow
import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
    openFeedbackModal: Function,
    showWidget: boolean,
    textId: string,
    useLink: boolean,
};

const FeedbackLink = (props: Props) => {
    const formLinkClick = () => {
        props.openFeedbackModal();
    };

    const { showWidget = true, textId, useLink } = props;

    const deskWidget = useLink ? (
        <a onClick={formLinkClick} href="#">
            <FormattedMessage id={textId} />
        </a>
    ) : (
        <div className="form-link-container" id="desk-form-link-container">
            <a className="form-link" href="#" onClick={formLinkClick}>
                <FormattedMessage id="feedback.feedback" />
            </a>
        </div>
    );
    return <Fragment>{showWidget && deskWidget}</Fragment>;
};

export default React.memo<Props>(FeedbackLink);
